<template>
  <div class="mt-6 -mb-1 flex flex-wrap" v-if="collection">
      <Link v-if="showPage(index)"
            preserve-state
            v-for="index in collection.last_page" :key="index" :data="params"
            class="mr-1 mb-1 px-4 py-3 text-sm border rounded hover:bg-white"
            :class="{ 'bg-white': true, 'ml-auto': false, 'border-ezdBlue': index === collection.current_page }"
            :href="createUrl(index)">{{ index }}</Link>
  </div>
</template>

<script>
    import { Link } from '@inertiajs/vue2';
    export default {
        components: {
            Link
        },
        props: {
            collection: Object,
            url: String,
            params: Object
        },
        data() {
            return {}
        },
        methods: {
            createUrl(index) {
                return this.url + '?page=' + index
            },
            showPage(index) {
                let totalPages = this.collection.last_page;
                let currentPage = this.collection.current_page;
                if (totalPages < 10 || 1 === index) {
                    return true;
                }
                return (((index >= (currentPage - 1) && index <= currentPage + 2) || (index >= totalPages - 2)));
            }
        }
    }
</script>
